<ng-container *ngIf="initEnd" [ngSwitch]="processPage">
  <app-consent *ngSwitchCase="'CONSENT'"></app-consent>

  <app-bank-choice *ngSwitchCase="'BANK_CHOICE'"></app-bank-choice>

  <app-login
    *ngSwitchCase="'LOGIN'"
    [errorMessage]="connectionErrorMesage"
  ></app-login>
  
  <app-sca-waiting
    *ngSwitchCase="'SCA_WAITING_SCREEN'"
  ></app-sca-waiting>

  <app-error
    *ngSwitchCase="'ERROR'"
  ></app-error>

  <app-select-accounts
    *ngSwitchCase="'SELECT_ACCOUNTS'"
  ></app-select-accounts>

  <app-none-accounts-found
    *ngSwitchCase="'NONE_ACCOUNTS'"
  ></app-none-accounts-found>

  <app-accounts-answer
    *ngSwitchCase="'SELECT_ACCOUNTS_ANSWER'"
  ></app-accounts-answer>

  <app-wait-on-external-bank-login
    *ngSwitchCase="'WAIT_ON_EXTERNAL_BANK_LOGIN'"
  ></app-wait-on-external-bank-login>

  <app-bank-connection-failure-retry
    *ngSwitchCase="'BANK_CONNECTION_FAILURE_RETRY'"
  ></app-bank-connection-failure-retry>
</ng-container>
